import { get, post, patch } from './agent';

export default {
  get: () => get('/slack'),
  getWorkspaces: () => get('/slack/workspaces'),
  authorize: ({ code, workspaceId }) => post('/slack/authorizations', { code, workspaceId }),
  getAuthorization: ({ token }) => get(`/slack/authorizations/${token}`),
  patchAuthorization: ({ token, workspaceId }) => patch(`/slack/authorizations/${token}`, { workspaceId }),
};
